import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationService,
  TaxObjectAppEntityTaxObjectWrite,
  TaxObjectService
} from '../openapi';
import { forkJoin, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForestCommonService {
  constructor(
    private taxObjectService: TaxObjectService,
    private applicationService: ApplicationService
  ) {
  }

  public updateForestsData(
    application: ApplicationAppEntityApplicationRead,
    forests: TaxObjectAppEntityTaxObjectWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    const requests = application?.taxObjects?.map((forest) => this.taxObjectService.deleteTaxObjectTaxObjectItem({
      id: forest?.uuid || ''
    })) || [];

    forests.forEach((forest) => {
      requests.push(this.taxObjectService.postTaxObjectTaxObjectCollection({
        taxObject: {
          ...forest,
          application: application.uuid
        }
      }));
    });
    return (requests.length ? forkJoin(requests) : of([])).pipe(
      switchMap(() => this.applicationService.getApplicationItemApplicationItem({ id: application?.uuid || '' }))
    );
  }
}
